import { useContext } from 'react';
import { ReportTemplatesContext } from '..';
import { Box, Typography } from '@mui/material';
import { RemoveBlockSVG } from './HelperSVGs';
import '../template.module.css';
import BlockNameHeading from './BlockNameHeading';
import { GenericBlock } from './GenericBlocks';

export function StatsMSABlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  const styles = {
    rowContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',
      width: '100%',
    },
  };

  return (
    <Box
      sx={{
        flex: '1 0 100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Lato',
          fontSize: '1.2rem',
          fontWeight: '600',
        }}
      >
        San Francisco-Oakland-Berkeley, CA
      </Typography>
      <Box sx={styles.rowContainer}>
        <GenericBlock title='Housing Affordability Index' sectionKey='msa' />
        <GenericBlock title='Wealth Index' sectionKey='msa' />
        <GenericBlock title='Population Growth Rate' sectionKey='msa' />
        <GenericBlock title='Total Population' sectionKey='msa' />
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock('Stat Block', 'msa');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function DiversificationBlock({ title }) {
  const { removeBlock } = useContext(ReportTemplatesContext);

  const styles = {
    boxStyle: {
      borderBottom: '2px solid gray',

      display: 'flex',
      gap: '1rem',
      padding: '0.5rem',
    },
    typographyStyle: {
      fontFamily: 'Lato',
      fontSize: '1.2rem',
      fontWeight: '600',
    },
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
        alignItems: 'center',
        padding: '1.5rem',
      }}
    >
      <Box sx={styles.boxStyle}>
        <Typography
          sx={{
            ...styles.typographyStyle,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={styles.boxStyle}>
        <Typography
          sx={{
            ...styles.typographyStyle,
            fontWeight: '900',
          }}
        >
          0.66
        </Typography>
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock(title, 'msa');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function Top5Block({ title }) {
  const { removeBlock } = useContext(ReportTemplatesContext);

  const data = {
    'Top 5 Businesses by Sector': [
      {
        title: '2023 Total Businesses (NAICS)',
        value: '219,230',
      },
      {
        title: '2023 Retail Trade Businesses (NAICS)',
        value: '219,230',
      },
      {
        title: '2023 Other Service excl Pub Admin Bus (NAICS)',
        value: '219,230',
      },
      {
        title: '2023 Prof/Scientific/Tech Service Bus (NAICS)',
        value: '219,230',
      },
      {
        title: '2023 HealthCare/Social Assist Bus (NAICS)',
        value: '219,230',
      },
    ],
    'Top 5 Employers by Sector': [
      {
        title: '2023 Total Employees (NAICS)',
        value: '2,239,078',
      },
      {
        title: '2023 HealthCare/Social Assist Emp (NAICS)',
        value: '2,239,078',
      },
      {
        title: '2023 Retail Trade Employees (NAICS)',
        value: '2,239,078',
      },
      {
        title: '2023 Prof/Scientific/Tech Service Emp (NAICS)',
        value: '2,239,078',
      },
      {
        title: '2023 Accommodation/Food Service Emp (NAICS)',
        value: '2,239,078',
      },
    ],
  };

  const styles = {
    typography: {
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: '400',
    },
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
        alignItems: 'center',
        padding: '1.5rem',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#F9F9F9',
          display: 'flex',
          paddingX: '1.5rem',
          paddingY: '.5rem',
          borderRadius: '1.2rem',
        }}
      >
        <BlockNameHeading title={title} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '.5rem',
        }}
      >
        {data[title].map((dict, index) => {
          return (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '.5rem',
                paddingY: '.25rem',
                borderBottom: '2px solid gray',
              }}
            >
              <Typography sx={styles.typography}>{dict.title}</Typography>
              <Typography
                sx={{
                  ...styles.typography,
                  fontWeight: '900',
                  fontSize: '1.25rem',
                }}
              >
                {dict.value}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock(title, 'msa');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}
